import { Image } from '@chakra-ui/react';
import {
    BingoBinglesId,
    LeviathanDuckatsId,
    LeviathanQuantumId,
    StreamGoldId,
} from '../../service/inventory';
import StreamGoldIcon from '../../assets/store/StreamGold.png';
import BinglesIcon from '../../assets/store/BingoBingles.png';
import QuantumIcon from '../../assets/store/LeviathanQuantum.png';
import DuckatsIcon from '../../assets/store/LeviathanDuckats.png';

interface DisplayCurrencyProps {
    itemID: string;
}

const displayCurrency = (id: string) => {
    switch (id) {
        case StreamGoldId:
            return <Image src={StreamGoldIcon} />;
        case BingoBinglesId:
            return <Image src={BinglesIcon} />;
        case LeviathanQuantumId:
            return <Image src={QuantumIcon} />;
        case LeviathanDuckatsId:
            return <Image src={DuckatsIcon} />;
    }

    return <></>;
};

export const CurrencyIcon: React.FC<DisplayCurrencyProps> = ({ itemID }) => {
    return displayCurrency(itemID);
};
